import { render, staticRenderFns } from "./AppDropdown.vue?vue&type=template&id=099de605&scoped=true&"
import script from "./AppDropdown.vue?vue&type=script&lang=ts&"
export * from "./AppDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099de605",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099de605')) {
      api.createRecord('099de605', component.options)
    } else {
      api.reload('099de605', component.options)
    }
    module.hot.accept("./AppDropdown.vue?vue&type=template&id=099de605&scoped=true&", function () {
      api.rerender('099de605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/ui/select/AppDropdown.vue"
export default component.exports